// extracted by css-extract-rspack-plugin
export default {"numberInput":"NumberInputCell_numberInput__Z3fPy"};